import React from "react";
import emptyStateImg from "../../assets/empty-state.png";

const SECTION_MESSAGES = {
  Menus: "No menus available.",
  Vendor: "No vendors are available at the moment.",
  User: "No users found in this section.",
  coupons: "No coupons have been added.",
  claimrequests: "No claim requests have been submitted.",
  Feedback: "No feedbacks have been submitted yet.",
  payoutrequests: "No payout requests have been made.",
  drinktypes: "No drink types available.",
  enquiries: "No enquiries have been submitted.",
  claimRequestDetails: "No claim requests.",
  mergerequests:
    "No merge requests found. Merge requests will appear here when vendors request to merge cafes or when admins suggest merges.",
  VendorApplications: "No vendor applications are pending review.",
  orderahead: "No Order Ahead requests are pending review.",
};

const CAFE_STATUS_MESSAGES = {
  Pending: "No Pending Cafe Requests.",
  Rejected: "No Cafes Rejected.",
  Approved: "No Cafes Approved.",
};

const getMessage = (section, searchState, cafeStatus) => {
  if (searchState) {
    return "No results found. Check your spelling or try a different search term.";
  }
  if (section === "Cafe") {
    return CAFE_STATUS_MESSAGES[cafeStatus] || "No cafes have been added yet.";
  }
  return SECTION_MESSAGES[section] || "This section is currently empty.";
};

const EmptyState = ({ section, searchState, cafeStatus, compact = false }) => {
  const message = getMessage(section, searchState, cafeStatus);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: compact ? "24px 20px" : "40px 20px",
        minHeight: compact ? "280px" : "400px",
      }}
    >
      <img
        src={emptyStateImg}
        alt="No data available"
        style={{
          width: compact ? "220px" : "380px",
          height: compact ? "220px" : "380px",
          objectFit: "contain",
          marginBottom: 0,
          opacity: 0.9,
          padding: compact ? "8px 8px 0 8px" : "16px 16px 0 16px",
        }}
      />
      <h6
        style={{
          color: "#6c757d",
          fontSize: "20px",
          textAlign: "center",
          maxWidth: "400px",
          lineHeight: "1.5",
        }}
      >
        {message}
      </h6>
    </div>
  );
};

export default EmptyState;
